export default "__VITE_ASSET__ClrOUPg$__"